var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-10"},[_c('title-page',{attrs:{"icon":"mdi-file-chart-outline"}},[_vm._v(" "+_vm._s(_vm.$t('reports.usages.usages'))+" ")]),_c('v-breadcrumbs',{attrs:{"items":[
          {text: _vm.$t('reports.reports'), to: {name: 'reports'}, exact: true},
          {text: _vm.$t('reports.usages.usages')},
      ],"divider":">"}}),_c('report-usages-list')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }